import styled from 'styled-components';
import { rgba } from 'polished';
import MuiCardMedia from '@mui/material/CardMedia';
import MuiCardContent from '@mui/material/CardContent';
import MuiCard from '@mui/material/Card';
import Avatar from '../../../../atoms/Avatar';
import { devices } from '../../../../../config/devices';

export const CardContent = styled(MuiCardContent)`
  display: flex;
  flex-basis: 100%;
  color: ${({ theme }) => theme.white};

  &.MuiCardContent-root {
    padding-right: 5rem;
    padding-left: 5rem;
    @media ${devices.xs} {
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-basis: 100%;
  align-items: center;
  /* text-align: center; */

  @media ${devices.xs} {
    flex-direction: column-reverse;
    text-align: center;
  }

  h4,
  h3 {
    color: ${({ theme }) => theme.white};
  }

  .MuiTypography-overline {
    line-height: 1.66;
  }
  a {
    color: ${({ theme }) => theme.primary.main};
    text-decoration: underline;
  }
`;

export const Card = styled(MuiCard)`
  && {
    /* border-radius: 13px; */
    display: flex;
    flex-direction: column;
    height: 16.375rem;
    @media ${devices.xs} {
      height: 18.75rem;
    }
    border: none;
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
`;

export const CardMedia = styled(MuiCardMedia)`
  /* height: 262px; */
  display: flex;
  flex-basis: 100%;
`;

export const BlackShade = styled.div`
  display: flex;
  flex-direction: inherit;
  height: 100%;
  min-width: 40rem;
  ${({ theme }) =>
    theme &&
    `
    background-color:${rgba(theme.common.black, 0.35)};
    `}

  background: linear-gradient(180deg, rgba(33, 33, 33, 0) 0%, rgba(49, 47, 47, 0.75) 100%), rgba(33, 33, 33, 0.35);
`;

export const Statistics = styled.div`
  /* justify-content: flex-start; */
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex-wrap: wrap;
`;

export const StatisticsItem = styled.span`
  display: flex;
  align-items: flex-end;

  svg {
    font-size: inherit;
    margin-right: 15px;
  }

  ${({ gutter }) =>
    gutter &&
    `
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  `}

  ${({ primary, theme }) =>
    primary &&
    `
  color: ${theme.red[100]};
  `}

@media ${devices.xs} {
    justify-content: center;
  }
`;

export const OrgAvatar = styled(Avatar)`
  border: 2px solid ${({ theme }) => theme.primary.main};
`;
